import React, { FC } from "react";
import { Aligment, Button, Icon, Text } from "venice-ui";
import { useStoreState } from "../../store";

interface IEmptyState {
  title: string;
  action?: any;
  actionLabel?: string;
}
export const EmptyState: FC<IEmptyState> = ({ title, action, actionLabel }) => {
  const {orgRole} = useStoreState((state) => state.user.userDetails);
  return (
    <Aligment direction="column" gap={20} vPadding="50px">
      <Icon name="info" size={48} iconBgHoverColor="transparent"/>
      <Text>{title}</Text>
      {action && (
        <Button
          text={actionLabel ? actionLabel : "Click me"}
          onClick={action}
          disabled={orgRole === "readOnly"}
        />
      )}
    </Aligment>
  );
};
